import {useState, useEffect} from 'react';

interface AudioMeterProps {
  levelReader: () => number;
}

const BOX_COLORS = [
  'green',
  'emerald',
  'teal',
  'cyan',
  'sky',
  'blue',
  'indigo',
  'violet',
  'purple',
  'fuchsia',
  'pink',
  'rose',
];

const METER_BOX_COUNT = 24;
const coloring = new Array(METER_BOX_COUNT);
const middle = METER_BOX_COUNT / 2;
for (let i = 0; i < middle; i++) {
  const color = `bg-${BOX_COLORS[i]}-600`;
  coloring[middle + i] = color;
  coloring[middle - i - 1] = color;
}

// The levelReader will return a value between 0 and 255
export function AudioMeter({levelReader}: AudioMeterProps) {
  const [opacities, setOpacities] = useState<number[]>(Array(METER_BOX_COUNT).fill(0));

  // TODO - make sure this only runs once, maybe look into a different hook for this
  // since useEffect gets called twice when not running in strict mode
  useEffect(() => {
    // 50ms interval should give us a 20FPS refresh rate
    setInterval(() => {
      const level = (levelReader() / 255) * middle;
      if (level > 0) {
        const newOpacities = new Array(METER_BOX_COUNT);
        for (let i = 1; i <= Math.floor(METER_BOX_COUNT / 2); i++) {
          const opacity = i < level ? 100 : 0;
          newOpacities[middle + i - 1] = opacity;
          newOpacities[middle - i] = opacity;
        }
        setOpacities(newOpacities);
      } else {
        setOpacities(Array(METER_BOX_COUNT).fill(0));
      }
    }, 50);
  }, []);

  return (
    <div className="w-full h-full overflow-hidden">
      <div className="w-full h-full flex flex-row gap-px py-1">
        {Array.from({length: METER_BOX_COUNT}, (_, i) => (
          <div
            key={i}
            className={`w-8 rounded-sm ${coloring[i]} h-auto flex-1 opacity-${opacities[i]} transition-opacity duration-500`}
          />
        ))}
      </div>
    </div>
  );
}
